module.exports = __webpack_public_path__ + "static/media/next_disabled.1935a42c.svg";